module.exports = __webpack_public_path__ + "media/src/images/abouts/brands/yoshinoya-d0b77dd9ee89361b7429634524827be9.jpg";